export interface Indexable {
  [key: string]: any;
}

export default function mergeProps<T extends Indexable, T2 extends Indexable>(
  obj: T,
  newObj: T2,
): T | T2 | undefined {
  if (newObj === undefined) {
    return undefined;
  }
  // If setting to a different object type, don't merge any props
  if (!Object.getPrototypeOf(obj).isPrototypeOf(newObj)) {
    return newObj;
  }

  const clone: any = {};

  Object.keys(newObj).forEach(key => {
    const exists = obj.hasOwnProperty(key);
    if (!exists) {
      clone[key] = newObj[key];
    } else {
      if (typeof obj[key] === 'object' && !Array.isArray(obj[key])) {
        clone[key] = mergeProps(obj[key] as Indexable, newObj[key] as Indexable);
      } else {
        clone[key] = newObj[key];
      }
    }
  });

  // Copy old props that are not present in new object only if this is a simple object
  Object.keys(obj).forEach(key => {
    const exists = newObj.hasOwnProperty(key);
    if (!exists) {
      clone[key] = obj[key];
    }
  });

  // Set prototype of cloned object to match original
  Object.setPrototypeOf(clone, Object.getPrototypeOf(obj));

  return clone;
}



// WEBPACK FOOTER //
// ./src/actions/merge.ts